import Vue from 'vue'
import VueRouter from 'vue-router'
import { getStoredUser, isUserRole, FRONT_HOME_PATH } from '@/utils/auth'

// 解决重复点击路由报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/manager',
    name: 'Manager',
    component: () => import('../views/Manager.vue'),
    redirect: '/manager/home',
    children: [
      { path: '403', name: 'Auth', meta: { name: '无权限' }, component: () => import('../views/manager/Auth.vue') },
      { path: 'home', name: 'ManagerHome', meta: { name: '系统首页' }, component: () => import('../views/manager/Home.vue') },
      { path: 'admin', name: 'Admin', meta: { name: '管理员信息', requireAdmin: true }, component: () => import('../views/manager/Admin.vue') },
      { path: 'user', name: 'User', meta: { name: '用户信息', requireAdmin: true }, component: () => import('../views/manager/User.vue') },
      { path: 'person', name: 'ManagerPerson', meta: { name: '个人信息' }, component: () => import('../views/manager/Person.vue') },
      { path: 'tables', name: 'Tables', meta: { name: '数据库表信息' }, component: () => import('../views/manager/Tables.vue') },
      { path: 'project', name: 'Project', meta: { name: '项目信息', requireAdmin: true }, component: () => import('../views/manager/Project.vue') },
      { path: 'projectType', name: 'ProjectType', meta: { name: '项目类型信息', requireAdmin: true }, component: () => import('../views/manager/ProjectType.vue') },
      { path: 'tags', name: 'Tags', meta: { name: '标签信息', requireAdmin: true }, component: () => import('../views/manager/Tags.vue') },
      { path: 'fileType', name: 'FileType', meta: { name: '文档类型信息', requireAdmin: true }, component: () => import('../views/manager/FileType.vue') },
      { path: 'projectNote', name: 'ProjectNote', meta: { name: '项目笔记信息', requireAdmin: true }, component: () => import('../views/manager/ProjectNote.vue') },
      { path: 'orderDownloadLog', name: 'OrderDownloadLog', meta: { name: '下载记录', requireAdmin: true }, component: () => import('../views/manager/OrderDownloadLog.vue') },
      { path: 'sysLog', name: 'SysLog', meta: { name: '系统日志', requireAdmin: true }, component: () => import('../views/manager/SysLog.vue') },
      { path: 'customDevelop', name: 'ManagerCustomDevelop', meta: { name: '定制开发', requireAdmin: true }, component: () => import('../views/manager/CustomDevelop.vue') },
      { path: 'qa', name: 'ManagerQa', meta: { name: '问题答疑', requireAdmin: true }, component: () => import('../views/manager/Qa.vue') },
    ]
  },
  {
    path: '/',
    name: 'Front',
    component: () => import('../views/front/Front.vue'),
    children: [
      { path: '', name: 'FrontHome', meta: { name: '首页信息' }, component: () => import('../views/front/Home.vue') },
      { path: 'ai', name: 'AiLibrary', meta: { name: 'AI实战库' }, component: () => import('../views/front/AiLibrary.vue') },
      { path: 'free', name: 'Free', meta: { name: '免费教程' }, component: () => import('../views/front/Free.vue') },
      { path: 'person', name: 'FrontPerson', meta: { name: '个人信息' }, component: () => import('../views/front/Person.vue') },
      { path: 'password', name: 'Password', meta: { name: '修改密码' }, component: () => import('../views/front/Password.vue') },
      { path: 'projectDetail', name: 'ProjectDetail', meta: { name: '修改密码' }, component: () => import('../views/front/ProjectDetail.vue') },
      { path: 'projectFreeDetail', name: 'ProjectFreeDetail', meta: { name: '免费项目详情信息' }, component: () => import('../views/front/ProjectFreeDetail.vue') },
      { path: 'projectNoteFreeDetail', name: 'ProjectNoteFreeDetail', meta: { name: '项目笔记详情信息' }, component: () => import('../views/front/ProjectNoteFreeDetail.vue') },
      { path: 'payResult', name: 'PayResult', meta: { name: '支付结果' }, component: () => import('../views/front/PayResult.vue') },
      { path: 'myOrder', name: 'MyOrder', meta: { name: '我的订单' }, component: () => import('../views/front/MyOrder.vue') },
      { path: 'deploymentService', name: 'DeploymentService', meta: { name: '项目部署服务' }, component: () => import('../views/front/DeploymentService.vue') },
      { path: 'customDevelop', name: 'CustomDevelop', meta: { name: '项目定制' }, component: () => import('../views/front/CustomDevelop.vue') },
      { path: 'qa', name: 'Qa', meta: { name: '问题答疑' }, component: () => import('../views/front/Qa.vue') },
      { path: 'myNotice', name: 'MyNotice', meta: { name: '我的工单与答疑' }, component: () => import('../views/front/MyNotice.vue') },
      { path: 'terms', name: 'Terms', meta: { name: '用户服务协议' }, component: () => import('../views/front/Terms.vue') },
      { path: 'privacy', name: 'Privacy', meta: { name: '隐私政策' }, component: () => import('../views/front/Privacy.vue') },
    ]
  },
  { path: '/home', redirect: to => ({ path: '/', query: to.query, hash: to.hash }) },
  { path: '/login', name: 'Login', meta: { name: '登录' }, component: () => import('../views/Login.vue') },
  {
    path: '/login2',
    redirect: to => ({
      path: FRONT_HOME_PATH,
      query: {
        login: '1',
        ...(to.query.redirect ? { redirect: to.query.redirect } : {})
      }
    })
  },
  { path: '/register', name: 'Register', meta: { name: '注册' }, component: () => import('../views/Register.vue') },
  { path: '*', name: 'page-404', meta: { name: '无法访问' }, component: () => import('../views/404.vue')},
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const user = getStoredUser()
  const whiteList = ['/login', '/register']

  if (to.matched.length === 0) {
    next({ name: 'page-404' })
    return
  }

  if (isUserRole(user) && (to.path === '/login' || to.path.startsWith('/manager'))) {
    next(FRONT_HOME_PATH)
    return
  }

  if (whiteList.includes(to.path)) {
    next()
    return
  }

  if (to.path.startsWith('/manager')) {
    if (!user.id) {
      next('/login')
      return
    }
    const requireAdmin = to.matched.some(record => record.meta.requireAdmin)
    if (requireAdmin && user.role !== 'ADMIN') {
      next('/manager/403')
      return
    }
  }

  next()
})

export default router
